// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3NlvB","fileBtn":"File_fileBtn__18LR6","closeBtn":"File_closeBtn__2nUSE","fileSelected":"File_fileSelected__l9An-","disabled":"File_disabled__2rKz6"};